module.exports = __webpack_public_path__ + "img/appIcon_supplierAndroid.4066856b.png";